<template>
	<el-dialog :visible.sync="showPreview" class="demo-dialog" :before-close="swiperClose">
		<el-carousel :autoplay="false" class="picsCard">
			<el-carousel-item v-for="(item, index) in picsList" :key="item+index">
				<el-image :src="item"></el-image>
			</el-carousel-item>
		</el-carousel>
	</el-dialog>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import wmsApi from '@/request/wmsApi';
	export default {
		name: 'PictureSwiper',
		props: {
			filesList: {
				type: Array,
				default: () => [],
				required: true
			},
			showPreview: {
				type: Boolean,
				default: false,
				required: true
			}
		},
		data() {
			return {
				picsList: [],
			}
		},
		methods: {
			swiperClose(done) {
				this.$emit('closeSwiper')
				done();
			},
		},
		computed: mapState({
			// 用户登陆后的帐号
			token: state => state.user.token,
		}),
		watch: {
			filesList(newVal, oldVal) {
				this.picsList = [];
				newVal.forEach((item, index) => {
					if (item.id)
						this.picsList.push(wmsApi.GetDownloadUrl(this.token, item.id));
				})
				console.log('picsList=>', this.picsList);
			}
		}
	}
</script>

<style>
	.demo-dialog .el-dialog {
		margin-top: 5vh !important;
	}
	
	.demo-dialog::-webkit-scrollbar {
		width: 0 !important;
	}
	.picsCard .el-carousel__container{
		height: 600px;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/PurchasingManagement/PictureSwiper.vue